import React from 'react';

const PartnerPagination = ({
  currentPage,
  totalPages,
  totalItems,
  startIndex,
  endIndex,
  itemLabel = 'items',
  onPageChange,
  className = '',
}) => {
  if (totalItems === 0) {
    return null;
  }

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className={`partner-pagination ${className}`.trim()}>
      <p className="partner-pagination-summary">
        Showing
        {' '}
        <strong>
          {startIndex}
          –
          {endIndex}
        </strong>
        {' '}
        of
        {' '}
        <strong>{totalItems}</strong>
        {' '}
        {itemLabel}
      </p>
      <div className="partner-pagination-controls">
        <button
          type="button"
          className="partner-pagination-btn"
          onClick={handlePrevious}
          disabled={currentPage <= 1}
        >
          Previous
        </button>
        <span className="partner-pagination-page">
          Page {currentPage} of {totalPages}
        </span>
        <button
          type="button"
          className="partner-pagination-btn"
          onClick={handleNext}
          disabled={currentPage >= totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PartnerPagination;
